import { ROLE_RANKING } from "./getHighestRoleLevel.constants";

/**
 * Return the highest role level from a list of user roles
 * @param {Array<String>} roles
 * @returns {UserRoleEnum}
 */
const getHighestRoleLevel = (roles) => {
  return ROLE_RANKING.find((role) => roles?.includes(role));
};

export default getHighestRoleLevel;
